import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-67">
      <div className="max-w-4xl mx-auto text-center" data-id="element-68">
        <div className="text-[#F97316] text-3xl font-black tracking-widest mb-8" data-id="element-69">
          🥊 MEGAPACK BOXEO LISTO 2026™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-70">
          El próximo lunes puedes volver a improvisar la clase.
        </h2>
        <p className="text-[#F97316] text-2xl sm:text-3xl font-black mb-10" data-id="element-71">
          O puedes entrar al gimnasio con todo resuelto desde hoy.
        </p>

        <div className="bg-[#1a0f00] border border-[#F97316]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-72">
          <div className="p-4 bg-[#0d0700] border-b border-[#F97316]/30 text-center font-bold text-white" data-id="element-73">
            📊 ¿CUÁNTO CUESTA NO TENERLO?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#0d0700] border-b border-[#F97316]/30" data-id="element-74">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-75">
              SIN MEGAPACK
            </div>
            <div className="p-4 font-bold text-[#F97316] text-center sm:border-l border-[#F97316]/30" data-id="element-76">
              CON MEGAPACK
            </div>
          </div>
          {[{
          without: '100+ horas/año planificando desde cero',
          with: '5 min/semana. El resto es entrenar'
        }, {
          without: 'Clases improvisadas → mismo error por meses',
          with: '140 clases listas → el progreso es visible'
        }, {
          without: 'Alumnos que abandonan sin saber por qué',
          with: 'Sistema de retención → permanencia alta'
        }, {
          without: 'Sin progresión clara → estancamiento',
          with: '6 tomos progresivos → mejoran y se quedan'
        }, {
          without: 'Sin Plan B cuando falta el equipo',
          with: 'Bono 3: 12 layouts para cualquier espacio'
        }, {
          without: 'Niveles mezclados = caos de clase',
          with: 'Bono 1: Método 3 Carriles → todos mejoran'
        }, {
          without: 'Guanteo que escala y genera problemas',
          with: 'Bono 5: Protocolo 3C → guanteo seguro siempre'
        }, {
          without: 'Sin sistema de medición de progreso',
          with: 'Fichas bimestrales → el avance es visible'
        }, {
          without: 'Sin identidad profesional',
          with: 'Sistema que justifica cobrar lo que realmente vales'
        }].map((row, i) => <div key={i} className={`grid grid-cols-1 sm:grid-cols-2 ${i < 8 ? 'border-b border-gray-800' : ''}`} data-id="element-77">
              <div className="p-4 text-gray-400 text-sm" data-id="element-78">{row.without}</div>
              <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-79">
                {row.with}
              </div>
            </div>)}
        </div>

        <div className="mb-4" data-id="element-80">
          <p className="text-white font-bold mb-4" data-id="element-81">
            ⏰ EL PRECIO DE LANZAMIENTO CIERRA EN:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-82" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-83">Después sube y no vuelve.</p>

        <h3 className="text-2xl font-black text-white mb-8" data-id="element-84">
          🛒 TUS OPCIONES FINALES
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-85">
          <div className="bg-[#0a0a0a] border border-[#F97316]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-86">
            <div className="text-2xl mb-2" data-id="element-87">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-88">MEGAPACK BOXEO LISTO</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-89">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-90">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-91">
                Antes: USD $24.90
              </p>
              <p className="text-[#F97316] text-2xl font-black mb-4" data-id="element-92">
                Hoy: USD $13.90
              </p>
              <a href="https://docentes2.edulabs.online/cart/43257056985206:1" className="btn-green-pulse block bg-[#F97316] text-black font-black py-4 rounded-lg hover:bg-[#FB923C] transition-colors text-sm" data-id="element-93">
                → QUIERO MI MEGAPACK BOXEO LISTO
              </a>
              <p className="text-gray-400 text-xs mt-3" data-id="element-94">
                💳 El cobro se realizará en la moneda local de tu país al tipo
                de cambio vigente.
              </p>
            </div>
          </div>

          <div className="bg-[#0d0700] border-2 border-[#F97316] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(249,115,22,0.2)] flex flex-col" data-id="element-95">
            <div className="text-2xl mb-2" data-id="element-96">🏆</div>
            <h3 className="text-[#F97316] font-black mb-1" data-id="element-97">
              MEGAPACK + MÉTODO GYM LLENO ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-1" data-id="element-98">
              La más elegida — AHORRAS USD $14
            </p>
            <p className="text-gray-400 text-xs mb-4" data-id="element-99">
              6 Tomos + 6 Bonos + Método Gym Lleno 2026™
              <br data-id="element-100" />
              (Sistema de precios, membresías, captación, retención y marketing
              local)
            </p>
            <div className="mt-auto" data-id="element-101">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-102">
                Antes: USD $33.90
              </p>
              <p className="text-[#F97316] text-3xl font-black mb-4" data-id="element-103">
                Hoy: USD $19.90
              </p>
              <a href="https://docentes2.edulabs.online/cart/43257060098166:1" className="btn-green-pulse block bg-[#F97316] text-black font-black py-4 rounded-lg hover:bg-[#FB923C] transition-colors text-sm" data-id="element-104">
                → QUIERO EL MEGAPACK + MÉTODO GYM LLENO
              </a>
              <p className="text-gray-400 text-xs mt-3" data-id="element-105">
                💳 El cobro se realizará en la moneda local de tu país al tipo
                de cambio vigente.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-106">
          <span data-id="element-107">🔒 Pago 100% seguro</span>
          <span data-id="element-108">⚡ Acceso en 5 minutos</span>
          <span data-id="element-109">🛡️ Garantía 7 días sin preguntas</span>
          <span className="w-full text-center mt-1 sm:w-auto sm:mt-0" data-id="element-110">
            💳 Tarjeta de crédito · Débito · PayPal · Pago local según tu país
          </span>
        </div>
      </div>
    </section>;
}